import React from "react";
import { Link } from "react-router-dom";
import { PiEnvelope } from "react-icons/pi";
import UploadArea from "./right-sidebar/UploadArea.tsx";
import "./FirstReceipt.css";

interface FirstReceiptProps {
  userEmail?: string;
  uploadError?: string | null;
  onFilesSelected: (files: FileList | null) => void;
}

// Shown in place of the dashboard's metrics, which are all zero without a receipt
const FirstReceipt: React.FC<FirstReceiptProps> = ({
  userEmail,
  uploadError,
  onFilesSelected,
}) => {
  return (
    <div className="first-receipt">
      <div className="first-receipt-intro">
        <h2>Add your first receipt</h2>
        <p>
          Save a receipt now and you can pay yourself back tax-free whenever you
          choose, while your HSA keeps growing. Any eligible expense since you
          opened your HSA counts, like a prescription or a dentist visit.
        </p>
      </div>

      <UploadArea showTitle={false} onFilesSelected={onFilesSelected} />
      {uploadError && (
        <p className="first-receipt-error" role="alert">
          {uploadError}
        </p>
      )}
      <p className="first-receipt-hint">
        A PDF or a photo works (JPG or PNG). We'll read the details for you to
        check.
      </p>

      <div className="first-receipt-email">
        <PiEnvelope size={24} />
        <p>
          Is it in your inbox? Forward it to{" "}
          <a href="mailto:upload@shoebox.io">upload@shoebox.io</a> from{" "}
          <strong>{userEmail || "your account email"}</strong>. Sending from
          another address? <Link to="/settings">Add it in Settings</Link>.
        </p>
      </div>
    </div>
  );
};

export default FirstReceipt;
